import i18n from "@/i18n";
import { format } from "date-fns";

// As datas vêm da API em UTC (meia-noite). Sem este ajuste, fusos negativos
// (ex.: Brasil, UTC-3) exibem o dia anterior. Reposiciona o instante para a
// meia-noite local antes de formatar.
const toLocalDate = (value: Date | string) => {
  const dateAux = new Date(value);
  dateAux.setUTCMinutes(dateAux.getUTCMinutes() + dateAux.getTimezoneOffset());
  return dateAux;
}

export const formattedDate = (value: Date) => {
  if (!value) {
    return '--';
  }
  return (
    (i18n.d(toLocalDate(value), 'short'))
  );
}

export const formattedYearsInterval = (year: number) => {
  const previousYear = year - 1;
  const yearAsStr = year.toString().slice(-2);

  return (
    `${previousYear}/${yearAsStr}`
  );
}


export const formattedMonthDay = (value: string) => {
  if (!value) {
    return "--";
  } else {
    return format(toLocalDate(value), "dd/MM");
  }
}

export const formattedMonthYear = (value: string) => {
  if (!value) {
    return "--";
  } else {
    return format(toLocalDate(value), "MM/yy");
  }
}

export const formattedCompleteDate = (value: string) => {
  if (!value) {
    return "--";
  } else {
    return format(toLocalDate(value), "dd/MM/yyyy");
  }
}

